import React, { useContext } from 'react'
import { TabsTrigger } from '@/components/ui/tabs'
import { PermissionsEnum } from 'api/Identity/Types/PermissionsEnum'
import { AuthSessionContext } from 'utils/AuthContext'
import { hasPermission } from 'utils/permissionsValidator'

import {
  TradingAccountNavigation,
  TradingAccountNavigationProps,
  TradingAccountTab,
} from './TradingAccountNavigation'

export const LiveTradingAccountNavigation: React.FC<TradingAccountNavigationProps> = (props) => {
  const [auth] = useContext(AuthSessionContext)
  const permissions = auth?.permissions || []

  return (
    <TradingAccountNavigation {...props}>
      <TabsTrigger value={TradingAccountTab.Details}>Details</TabsTrigger>

      {hasPermission(permissions, PermissionsEnum.CanViewTradingAccountStatistics) &&
        !props.hideTabs && (
          <TabsTrigger value={TradingAccountTab.Statistics}>Statistics</TabsTrigger>
        )}

      {hasPermission(permissions, PermissionsEnum.CanViewTradingAccountOpenPositions) &&
        !props.hideTabs && (
          <TabsTrigger value={TradingAccountTab.Positions}>Open positions</TabsTrigger>
        )}

      {hasPermission(permissions, PermissionsEnum.CanViewTradingAccountPendingOrders) &&
        !props.hideTabs && (
          <TabsTrigger value={TradingAccountTab.Orders}>Pending Orders</TabsTrigger>
        )}

      {hasPermission(permissions, PermissionsEnum.CanViewTradingAccountTransactions) &&
        !props.hideTabs && (
          <TabsTrigger value={TradingAccountTab.Transactions}>Transactions</TabsTrigger>
        )}

      {hasPermission(permissions, PermissionsEnum.CanViewTradingAccountPlatformTransactions) &&
        !props.hideTabs && (
          <TabsTrigger value={TradingAccountTab.PlatformTransactions}>
            Platform Transactions
          </TabsTrigger>
        )}
    </TradingAccountNavigation>
  )
}
